module.exports = __webpack_public_path__ + "static/img/info_1.5d0ac5c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2023/info_1.jpg
// module id = u1Oh
// module chunks = 4